import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Tabs } from '@frontend/design-system';
import { trackingId } from '../../../tracking';

export const RoutesTableTab = {
  CALL_ROUTES: 'call-routes',
  DEVICE_ROUTES: 'device-routes',
} as const;

export type RoutesTableTabType = (typeof RoutesTableTab)[keyof typeof RoutesTableTab];

export const RoutesTabs = ({
  selectedTab,
  setSelectedTab,
  trackingIdPrefix,
}: {
  selectedTab: RoutesTableTabType;
  setSelectedTab: (tab: RoutesTableTabType) => void;
  trackingIdPrefix?: string;
}) => {
  const { t } = useTranslation('phone');

  return (
    <Tabs initialTab={selectedTab} onChange={(tabId) => setSelectedTab(tabId as RoutesTableTabType)}>
      <Tabs.Bar
        css={css`
          max-width: fit-content;
        `}
      >
        <Tabs.Tab
          id={RoutesTableTab.CALL_ROUTES}
          trackingId={trackingId({
            context: 'setting',
            feature: 'call-routes',
            details: trackingIdPrefix + 'call-route-tab',
          })}
        >
          {t('Call Routes')}
        </Tabs.Tab>
        <Tabs.Tab
          id={RoutesTableTab.DEVICE_ROUTES}
          trackingId={trackingId({
            context: 'setting',
            feature: 'call-routes',
            details: trackingIdPrefix + 'device-route-tab',
          })}
        >
          {t('Device Routes')}
        </Tabs.Tab>
      </Tabs.Bar>
    </Tabs>
  );
};
